import { CaseDetailView } from '../components/CaseDetailView';

export function CaseDetailPage() {
  return <CaseDetailView />;
}